import { ThunkType } from "../../../../../core/store/reducers";
import createClientAccountApi from "../../api/clientAccount/createClientAccount";
import updateClientAccounttApi from "../../api/clientAccount/updateClientAccount";
import { setFetchStateAccount } from "../../clientsDataReducer";
import { ClientAccount } from "../../types";

export const upsertClientAccount = (account: ClientAccount): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return;
	}

	dispatch(setFetchStateAccount({ type: "started" }));

	const { userId } = store.data.auth.current.user;
	const result = account.monAccId
		? await dispatch(updateClientAccounttApi(userId, account))
		: await dispatch(createClientAccountApi(userId, account));

	if (result && result.resCode === "OK") {
		dispatch(setFetchStateAccount({ type: "successful", result: result.resDesc }));
		return result.resDesc;
	} else {
		dispatch(setFetchStateAccount({ type: "error", errorCode: result?.resCode }));
	}
};
